import { useState, useEffect } from "react";
import { i18n } from "@lingui/core";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "../../../redux/store";
import s from './PreSaleTimer.module.css'

const PreSaleTimer = () => {
    const { metadata } = useSelector((state: RootState) => state.game);
    const location = useLocation();

    // const targetDate = new Date("2025-06-21T00:00:00").getTime(); // Целевая дата
    const targetDate = new Date().getTime() + metadata.time_to_presale * 1000

    const calculateTimeLeft = () => {
        const now = new Date().getTime();
        const difference = targetDate - now;

        if (difference <= 0) {
            return {
                days: "00",
                hours: "00",
                minutes: "00",
                seconds: "00",
            };
        }

        const days = String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, "0");
        const hours = String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, "0");
        const minutes = String(Math.floor((difference / 1000 / 60) % 60)).padStart(2, "0");
        const seconds = String(Math.floor((difference / 1000) % 60)).padStart(2, "0");

        return { days, hours, minutes, seconds };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());


    useEffect(() => {
        calculateTimeLeft();

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const timerData = [
        { value: timeLeft.days, type: i18n._("Days") },
        { value: timeLeft.hours, type: i18n._("Hours") },
        { value: timeLeft.minutes, type: i18n._("Mins") },
        { value: timeLeft.seconds, type: i18n._("Sec") },
    ];
    const timerDataNoTranslate = [
        { value: timeLeft.days, type: "Days" },
        { value: timeLeft.hours, type: "Hours" },
        { value: timeLeft.minutes, type: "Mins" },
        { value: timeLeft.seconds, type: "Sec" },
    ];

    const dataToUse =
        location.pathname === "/welcome" ? timerDataNoTranslate : timerData;
    return (
        <div className={s.preSaleContainer}>

            <div className={s.timerContainer}>
                {dataToUse.map(({ value, type }) => (
                    <div key={type} className={s.timerItem}>
                        <p className={s.timerTextTop}>{value}</p>
                        <p className={s.timerTextBot}>{type}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PreSaleTimer